"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const oxygen_config_1 = require("@8x8/oxygen-config");
const ValueText_1 = __importDefault(require("../styled/ValueText"));
const Asterisk_1 = __importDefault(require("../styled/Asterisk"));
class Value extends react_1.PureComponent {
    constructor() {
        super(...arguments);
        this.renderContent = () => {
            const { value, showTooltipOnOverflow, isRequired } = this.props;
            if (showTooltipOnOverflow && typeof value === 'string') {
                return (react_1.default.createElement("span", { title: value },
                    value,
                    isRequired && react_1.default.createElement(Asterisk_1.default, { "aria-hidden": "true" }, "*")));
            }
            return (react_1.default.createElement(react_1.default.Fragment, null,
                value,
                isRequired && react_1.default.createElement(Asterisk_1.default, { "aria-hidden": "true" }, "*")));
        };
    }
    render() {
        const { htmlFor, isDisabled, shouldWrapText, testId } = this.props;
        return (react_1.default.createElement(ValueText_1.default, { ...(0, oxygen_config_1.getTestAttributes)(`${testId}_VALUE`), htmlFor: htmlFor, isDisabled: isDisabled, shouldWrapText: shouldWrapText }, this.renderContent()));
    }
}
exports.default = Value;
Value.defaultProps = {
    testId: 'LABEL',
    value: '',
    isRequired: false,
    isDisabled: false,
    shouldWrapText: false,
    showTooltipOnOverflow: true,
};
